import { gql } from "generated-graphql";

export const FACILITIES_BY_INTERNAL_TAG_NAME_QUERY = gql(`
  query FacilitiesByInternalTagName($tagName: String!, $search: String, $sort: [SortModel!]) {
    facilitiesByInternalTagName(tagName: $tagName, search: $search, sort: $sort) {
        items {
            id
            name
            streetAddress1
            streetAddress2
            city
            state
            zip
            tenant {
                id
                name
            }
        }
        count
    }
  }
`);
